import { localise } from '../lang/lang';
import { isForbiddenError, isNotFoundError, isServerError, isTooManyRequestsError, isValidationError, } from './error';
export const getErrorText = (error, noun) => {
    if (isNotFoundError(error)) {
        return noun
            ? `We could not find the ${noun} you are looking for.`
            : 'We could not find what you are looking for.';
    }
    if (isValidationError(error)) {
        return 'Please check your input and try again.';
    }
    if (isForbiddenError(error)) {
        return noun
            ? `You do not have permission to access this resource (${noun})`
            : 'You do not have permission to access this resource';
    }
    if (isTooManyRequestsError(error)) {
        return 'You are sending too many requests, please try again later.';
    }
    if (isServerError(error)) {
        return 'We are experiencing technical difficulties, please try again later or contact support.';
    }
    return localise('UNKNOWN_ERROR_MESSAGE');
};
